#import "./BusinessUnitFields.graphql"
query CompanyBusinessUnits(
  $first: Int
  $after: Cursor
  $orderBy: [CompanyBusinessUnitsOrderBy!]
  $filter: CompanyBusinessUnitFilter
) {
  companyBusinessUnits(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    nodes {
    ...BusinessUnitFields
    }
  }
}
